import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDecimalFloat(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M8 7C8 6.44772 8.44771 6 9 6C9.55228 6 10 6.44772 10 7V17C10 17.5523 9.55228 18 9 18C8.44772 18 8 17.5523 8 17V8.5C8 8.5 8 7.55228 8 7Z"
        fill="currentColor"
      />
      <path
        d="M13 6C12.4477 6 12 6.44772 12 7C12 7.55228 12.4477 8 13 8H18V11H13C12.4477 11 12 11.4477 12 12C12 12.5523 12.4477 13 13 13H18V16H13C12.4477 16 12 16.4477 12 17C12 17.5523 12.4477 18 13 18H19C19.5523 18 20 17.5523 20 17V7C20 6.44772 19.5523 6 19 6H13Z"
        fill="currentColor"
      />
      <path
        d="M6 16.5C6 17.3284 5.32843 18 4.5 18C3.67157 18 3 17.3284 3 16.5C3 15.6716 3.67157 15 4.5 15C5.32843 15 6 15.6716 6 16.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
